/**
 * Cẩm nang khách hàng
 */

import CopyToClipboard from './CopyToClipboard';

export default function Customers() {
    const selectors = {
        'wrapper' : '.js-customers-wrapper',
        'form' : '.js-filter-customers-form',
        'result' : '.js-customers-results',
        'pagination' : '.js-customers-pagination',
    };

    this.init = () => {
        let $form = jQuery(selectors.form);
        if (!$form.length) return;
        this.handleForm();
        this.display(jQuery(selectors.form));
        this.handlePagination();
    }

    this.template = () => {
        let compiled = null;
    
        compiled = _.template(
            '<div class="w-full relative h-0 pt-[57.58%] rounded-20px overflow-hidden">\n' +
            '    <img class="absolute bg-primary-light inset-0 w-full h-full object-cover" src="<%= image_url %>" width="521" height="300" alt="<%= name %>">\n' +
            '    <div class="absolute z-1 inset-0 w-full h-full xl:p-10 p-7 flex flex-col xl:justify-start justify-center">\n' +
            '        <p class="fieldstyle text-white font-medium lg:text-22px text-xl leading-tight uppercase">\n' +
            '            <%= title_other %>\n' +
            '        </p>\n' +
            '        <div class="xl:mt-5 mt-2.5">\n' +
            '            <a href="<%= url %>" \n' +
            '                class=" bg-white hover:bg-button-hover text-primary text-xs -tracking-button leading-tight inline-flex flex-row items-center py-1.5 md:px-6 px-4 rounded-10px gap-6px font-medium border border-primary transition-colors duration-400">\n' +
            '                Xem chi tiết\n' +
            '            </a>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>');
        return compiled;
    }

    this.templatePost = () => {
        let compiled = null;
    
        compiled = _.template(
            '<div class="group flex flex-col">\n' +
            '    <a class="first:mt-0 mt-4 relative block w-full h-0 pt-[100%]" href="<%= url %>">\n' +
            '        <img class="absolute inset-0 w-full h-full object-contain" src="<%= bg_common %>" width="269" height="269" alt="">\n' +
            '        <span class="absolute inset-0 w-full h-full p-27px">\n' +
            '            <img class="block w-full h-full object-contain" src="<%= image_url %>" width="269" height="269" alt="<%= name %>">\n' +
            '        </span>\n' +
            '    </a>\n' +
            '    <p class="first:mt-0 mt-4 fieldstyle text-black font-medium md:text-xl text-lg leading-tight">\n' +
            '        <a class="text-black group-hover:text-primary" href="<%= url %>"><%= name %></a>\n' +
            '    </p>\n' +
            '</div>'
        );


        return compiled;
    }

    this.templateDetail = () => {
        let compiled = null;
    
        compiled = _.template(
            '<div class="max-w-[853px] mx-auto">\n' +
            '    <div class="w-full text-center mb-10">\n' +
            '        <h1 class="fieldstyle font-medium text-primary md:text-40px text-3xl text-center">\n' +
            '            <%= name %>\n' +
            '        </h1>\n' +
            '    </div>\n' +
            '    <div class="wysiwyg sm:text-base text-sm font-normal text-black">\n' +
            '        <%= post_content %>\n' +
            '    </div>\n' +
            '    <div class="mt-10">\n' +
            '        \n' +
            '    </div>\n' +
            '    <div class="mt-10"><%= share_socials %></div>\n' +
            '</div>'
        );


        return compiled;
    }

    this.getAllCustomers = async (search, paged = 1) => {
        return jQuery.ajax({
            type : "GET",
            dataType : "JSON",
            url : theme_object.endpoint_url + 'customers_taxes',
            data : {
                q: search,
                paged: paged,
            },
            context: this
        })
    }

    this.getPostsCustomersByTermSlug = async (search, term_slug, paged = 1) => {
        return jQuery.ajax({
            type : "GET",
            dataType : "JSON",
            url : theme_object.endpoint_url + 'customers',
            data : {
                q: search,
                paged: paged,
                term_slug: term_slug
            },
            context: this
        })
    }

    this.handleForm = async () => {
        jQuery(selectors.form).on('submit', async (e) => {
            e.preventDefault(); 

            let $this = jQuery(e.target);
            $this.find('[name="paged"]').val(1)
            this.display($this);
            
            return false;
        })

    }

    this.display = async ($form) => {
        let search = $form.find('[name="search"]').val();
        let paged = parseInt($form.find('[name="paged"]').val());
        let wrapper = jQuery(selectors.wrapper);
        wrapper.find('.js-overlay').css({"display":"flex"});
        
        let term_slug = $form.data('term');

        if (term_slug){
            await this.getPostsCustomersByTermSlug(search, term_slug, paged).then( (res) => {
                if (res.data) {
                    let resultsDom = jQuery(selectors.wrapper).find(selectors.result);
                    resultsDom.empty();

                    if (res.meta.total == 1){
                        resultsDom.css('display', 'block');
                        let itemTemplate = this.templateDetail();

                        let item_data = res.data[0];
                        resultsDom.append(itemTemplate(item_data));

                        new CopyToClipboard().init();
                    }else{
                        let itemTemplate = this.templatePost();
                        for(let i in res.data) {
                            let item_data = res.data[i];
                            item_data['bg_common'] = res.meta.bg_common;
                            
                            resultsDom.append(itemTemplate(item_data));
                        }
                    }
                }

                if (res.meta) {
                    $form.find('[name="paged"]').val(res.meta.current_page)
                    $form.find('[name="total_pages"]').val(res.meta.total_pages)

                    if (res.meta.total_pages == 1){
                        jQuery(selectors.pagination).hide();
                    }else{
                        jQuery(selectors.pagination).css('display', '');
                        jQuery(selectors.pagination).html(this.pagination(res.meta.current_page, res.meta.total_pages))
                    }
                }
        
                wrapper.find('.js-overlay').hide();
            })
        }else{
            await this.getAllCustomers(search, paged).then( (res) => {
                if (res.data) {
                    let itemTemplate = this.template();
                    let resultsDom = jQuery(selectors.wrapper).find(selectors.result);
                    resultsDom.empty();
    
                    for(let i in res.data) {
                        let item_data = res.data[i];

                        if (!item_data['title_other']){
                            item_data['title_other'] = item_data['name'];
                        }
                        if (!item_data['image_url']){ item_data['image_url'] = ''; }
                        resultsDom.append(itemTemplate(item_data));
                    }
                }
    
                if (res.meta) {
                    $form.find('[name="paged"]').val(res.meta.current_page)
                    $form.find('[name="total_pages"]').val(res.meta.total_pages)
                    
                    if (res.meta.total_pages == 1){
                        jQuery(selectors.pagination).hide();
                    }else{
                        jQuery(selectors.pagination).css('display', '');
                        jQuery(selectors.pagination).html(this.pagination(res.meta.current_page, res.meta.total_pages))
                    }
                }
        
                wrapper.find('.js-overlay').hide();
            })
        }
    }

    this.handlePagination = () => {
        jQuery(selectors.pagination).on('click', 'a[data-page]', (e) => {
            e.preventDefault();
            let $this = jQuery(e.currentTarget);
            let $form = jQuery(selectors.form);
            let paged = $this.attr('data-page');
            $form.find('[name="paged"]').val(parseInt(paged))
            this.display($form);
        })
    }

    this.handleForm = async () => {
        jQuery(selectors.form).on('submit', async (e) => {
            e.preventDefault();

            let $this = jQuery(e.target);
            $this.find('[name="paged"]').val(1)
            this.display($this);

            return false;
        })
    }

    this.pagination = (currentPage, totalPages) => {
        if (totalPages == 1) 
            
            return '';

        let paginationHTML = '';
        let display;
        let next = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M1.01341 1L7 7L1.01341 13"stroke=#4D5761 stroke-linecap=round /></svg>'
        let prev = '<svg fill=none height=14 viewBox="0 0 8 14"width=8 xmlns=http://www.w3.org/2000/svg><path d="M6.98659 1L1 7L6.98659 13"stroke=#4D5761 stroke-linecap=round /></svg>'
        // Previous button
        if (currentPage > 1) {
            paginationHTML += `<a href="#" data-page="${currentPage - 1}" class="prev md:mr-10">${prev}</a>`;
        }

        // First page
        if (currentPage > 2) {
            paginationHTML += `<a href="#" data-page="1" class="text-lg text-gray-600 leading-tight font-light">01</a>`;
        }

        // Ellipsis before current page range
        if (currentPage > 3) {
            paginationHTML += `<span class="dots text-lg text-gray-600 leading-tight font-light">...</span>`;
        }

        // Page numbers around the current page
        let startPage = Math.max(1, currentPage - 1);
        let endPage = Math.min(totalPages, currentPage + 1);

        for (let i = startPage; i <= endPage; i++) {
            display = i;
            if(i<10 && i > 0) {
                display = '0'+i;
            }
            if (i === currentPage) {
                paginationHTML += `<span class="active text-lg text-primary leading-tight font-medium">${display}</span>`;
            } else {
                paginationHTML += `<a href="#" data-page="${i}" class="text-lg text-gray-600 leading-tight font-light">${display}</a>`;
            }
        }

        // Ellipsis after current page range
        if (currentPage < totalPages - 2) {
            paginationHTML += `<span class="dots text-lg text-gray-600 leading-tight font-light">...</span>`;
        }

        // Last page
        if (currentPage < totalPages - 1) {
            display = totalPages;
            if(totalPages < 10 && totalPages > 0) {
                display = '0'+totalPages;
            }
            paginationHTML += `<a href="#" data-page="${totalPages}" class="text-lg text-gray-600 leading-tight font-light">${display}</a>`;
        }

        // Next button
        if (currentPage < totalPages) {
            paginationHTML += `<a href="#" data-page="${currentPage + 1}" class="next md:ml-10">${next}</a>`;
        }

        return paginationHTML;
    }

}
